<template>
  <div>
    <ConfigListItem label="Status do Embarque" @click="openEditDialog">
      <v-chip small :color="chipData.color" :text-color="chipData.textColor">
        {{ chipData.text }}
        <v-icon small :right="!!chipData.text">{{ chipData.icon }}</v-icon>
      </v-chip>
    </ConfigListItem>

    <ODialog ref="dialog" :hideWhenLoading="true">
      <v-card>
        <ODialogBar title="Status do Embarque" @close="dismiss" />
        <v-card-text class="pa-6 d-flex flex-column gap-6">
          <OCapCont label="Atualização das configs">
            <b>2024-08-01 10:00</b> por <code>jose.ventura</code>
          </OCapCont>

          <OCapCont label="Mailbox de configs mais recente">
            <b>2024-08-01 10:00</b> por <code>jose.ventura</code>
          </OCapCont>

          <div class="d-flex flex-column align-center mt-10"
            v-if="vehicle.clientId != null">
            <v-btn class="w-300" @click="createMailbox">
              Criar mailbox de configs
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { Vehicle, MailboxItem } from '@/models'
import ConfigListItem from './ConfigListItem.vue'

const GREY = { color: 'grey lighten-1', textColor: 'black' }
const GREEN = { color: 'green lighten-1', textColor: 'white' }
// const YELLOW = { color: 'yellow lighten-1', textColor: 'black' }
// const RED = { color: 'red', textColor: 'white' }

const CHIP_UNKNOWN = { ...GREY, text: '', icon: 'mdi-dots-horizontal' }
const CHIP_OK = { ...GREEN, text: 'OK', icon: 'mdi-check' }
// const CHIP_DELIVERED = { ...GREEN, text: 'OK', icon: 'mdi-check-all' }
// const CHIP_OUTDATED = {
//   ...YELLOW,
//   text: 'Necessita embarque',
//   icon: 'mdi-alert'
// }
// const CHIP_CONFLICT = { ...RED, text: 'Conflito', icon: 'mdi-alert-octagram' }

export default {
  components: { ConfigListItem },
  props: {
    vehicle: { required: true },
    allConfigs: { required: true }
  },
  data() {
    return { chipData: CHIP_UNKNOWN }
  },
  mounted() {
    this.reload()
  },
  watch: {
    vehicle() {
      this.reload()
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    reload() {
      this.fetchData()
    },
    async fetchData() {
      this.chipData = CHIP_UNKNOWN
      // - busca mailbox de configsV2 mais recente (não-cancelado,
      // mas pode estar entregue ou não)
      // - busca dumpConfigs mais recente
      // - compara a maior data das configs atuais com a data do
      // mailbox para saber se está verde ou amarelo
      // - compara valores do dumpConfigs para saber se está vermelho
      await this.$delay(1000)
      this.chipData = CHIP_OK
    },
    async createMailbox() {
      this.$rootLoading(async () => {
        let res = await Vehicle.getConfigsHex(this.vehicle.id)
        if (res.hasError) {
          this.$snack('O mailbox de configs possui erros!', { color: 'red' })
          return
        }

        // NB: Veja adminapi/.../associate.js para o mesmo algoritmo
        let { allConfigs, address, previewHex } = res
        let originJson = {
          vehicleId: this.vehicle.id,
          vehicleCode: this.vehicle.code,
          orgCode: this.vehicle.org.name,
          allConfigs,
          bytes: previewHex,
          // Numérico (o receiver também aceita hex)
          address
        }

        // Novo tipo de mailbox criado para integração com vehicleman
        let information = 'configsV2'
        let cc = [this.vehicle.clientId]
        let label = 'ConfigsV2 manual'
        await MailboxItem.save({
          cc,
          label,
          information,
          originJson
        })

        this.$snack('Mailbox criado com sucesso')
        this.reload()
        this.dismiss()
      })
    }
  }
}
</script>

<style lang="sass"></style>
